import * as _ from 'lodash';
import * as toastr from 'toastr';

import * as UserManagement from '../';
import * as Common from '../../Common/modules';
import * as Models from '../../Models';
import * as Routes from '../../Routes';
import * as Services from '../../Services';

export interface IResidentialPaymentCaptureConfirmationScope extends ng.IScope {
  residentialPaymentCaptureConfirmationCtrl: ResidentialPaymentCaptureConfirmationCtrl;
}

export class ResidentialPaymentCaptureConfirmationCtrl {
  private customerNumber: string;
  private confirmationResult: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureConfirmationResponse;
  private formControlVariables =
    new Models.PaymentCapture.PaymentCaptureFormControlVariables.PaymentCaptureFormControlVariables();

  public static $inject = ["$scope", "$state", "PaymentCaptureApiClient", "$timeout", "$http"];

  constructor(
    public $scope: IResidentialPaymentCaptureConfirmationScope,
    private stateService: angular.ui.IStateService,
    private paymentCaptureApiClient: Services.PaymentCaptureApiClient.IPaymentCaptureApiClient,
    private $timeout: ng.ITimeoutService,
    private $http: ng.IHttpService,
  ) {
    this.customerNumber = this.stateService.params["customerNumber"];

    if (!!this.customerNumber) {
      var confirmationRequest =
        new Models.PaymentCapture.PaymentCaptureCustomer.ResidentialPaymentCaptureConfirmationRequest();
      confirmationRequest.customerNumber = this.customerNumber;
      this.paymentCaptureApiClient
        .getConfirmationInformation(confirmationRequest)
        .then((result: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureConfirmationResponse) => {
          this.formControlVariables.paymentResult = result.paymentCaptureResponse.responseMessage;
          this.formControlVariables.responseCode = result.paymentCaptureResponse.responseCode;

          if (result.paymentCaptureResponse.responseCode === -1) {
            this.formControlVariables.hasError = true;
          }

          this.confirmationResult = result;
          this.phoneNumberFormat(this.confirmationResult.phoneNumber);
        });
    }
  }

  public returnToHomePage = (): void => {
    this.stateService.go("main.customersearchv2");
  };

  public returnToCustomerProfile = (): void => {
    this.stateService.go("main.customerv2", { igsCustomerNumber: this.customerNumber });
  };

  private phoneNumberFormat = (primaryPhoneNumber: string): void => {
    var s2 = ("" + primaryPhoneNumber).replace(/\D/g, "");
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    this.confirmationResult.phoneNumber = !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
  };
}
